export default "__VITE_ASSET__DJ_BHp5$__"